import { completeOnboardingApi as generatedCompleteOnboardingApi } from '../generated/onboarding/completeOnboarding';
import { getSettingsProfileApi } from '../settings/getSettingsProfile';

const completeOnboardingApi = generatedCompleteOnboardingApi.enhanceEndpoints({
  endpoints: {
    completeOnboarding: {
      invalidatesTags: ['Onboard', 'OnboardProgress', 'SettingsProfile'],
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;

          dispatch(
            getSettingsProfileApi.util.updateQueryData('getSettingsProfile', undefined, (draft) => {
              draft.isOnboardCompleted = true;
            }),
          );
        } catch {
          // Do nothing on error - cache will be invalidated.
        }
      },
    },
  },
});

export const { useCompleteOnboardingMutation } = completeOnboardingApi;
